var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"notes-modal\" class=\"popup popup-notes\"><div ng-style=\"{'background': theme_color}\" class=\"head\"><h2>Notes</h2><a title=\"Close\" href=\"#\" ng-click=\"$dismiss()\" class=\"fancybox-item fancybox-close\"></a></div><div class=\"container\"><form><textarea placeholder=\"Click here to write a note\" ng-model=\"current_app.notes\" style=\"height:inherit;\"></textarea><input type=\"submit\" value=\"Save\" ng-click=\"update_notes()\"></form></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/appbundlesTable/notesModal/notesModal.jade
// module id = 435
// module chunks = 0